"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require("babel-runtime/helpers/extends");

var _extends4 = _interopRequireDefault(_extends3);

exports.default = user;
exports.isLoaded = isLoaded;
exports.load = load;
exports.markFreeSeen = markFreeSeen;
exports.activateTrial = activateTrial;
exports.setWorkInfo = setWorkInfo;

var _assetDownloads = require("./assetDownloads");

var _subscriptions = require("./subscriptions");

var _topups = require("./topups");

var _auth = require("./auth");

var _academicUsers = require("./academicUsers");

var _payments = require("./payments");

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = "ms/user/load";
var LOAD_SUCCESS = "ms/user/load_success";
var _LOAD_SUCCESS = "ms/user/_load_success";
var LOAD_FAIL = "ms/user/load_fail";

var ACTIVATE_TRIAL = "ms/subscriptions/activate";
var ACTIVATE_TRIAL_SUCCCESS = "ms/subscriptions/activate_success";
var ACTIVATE_TRIAL_FAIL = "ms/subscriptions/activate_fail";

var MARK_FREE_SEEN = "ms/subscriptions/mark_free_seen";
var MARK_FREE_SEEN_SUCCCESS = "ms/subscriptions/mark_free_seen_succcess";
var MARK_FREE_SEEN_FAIL = "ms/subscriptions/mark_free_seen_fail";

var initialState = {
  loading: false,
  loaded: false,
  loadError: false,

  activatingTrial: false,
  trialError: "",
  activatedTrial: false
};

// Reducer

function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _auth.UPDATE_PASSWORD_SUCCESS:
      return (0, _extends4.default)({}, state, {
        etag: action.result.etag
      });

    case LOAD:
      return (0, _extends4.default)({}, state, {
        loading: true
      });

    case LOAD_SUCCESS:
      return (0, _extends4.default)({}, state, action.result.user, {
        loading: false,
        loaded: true
      });

    case _LOAD_SUCCESS:
      return (0, _extends4.default)({}, state, {
        loading: false,
        loaded: true
      });

    case LOAD_FAIL:
      return (0, _extends4.default)({}, state, {
        loading: false,
        loaded: false,
        loadError: action.error
      });

    case _auth.LOGOUT_SUCCESS:
    case _auth.LOGIN_SUCCESS:
      return initialState;

    case _assetDownloads.ASSET_ACQUIRE_SUCCESS:
      if (action.result.isError) {
        return state;
      }

      return (0, _extends4.default)({}, state, {
        quota: (0, _extends4.default)({}, state.quota, {
          currentQuota: action.result.currentQuota // state.quota.currentQuota - action.meta.cost
        })
      });

    case _payments.SWITCH_TO_ANNUAL_SUCCESS:
    case _subscriptions.BUY_SUCCESS:
    case _subscriptions.BUY_UPGRADE_SUCCESS:
    case _payments.SUBSCRIBE_TO_UNREAL_UNLIMITED_SUCCESS:
      if (action.result.isError) {
        return state;
      }

      return (0, _extends4.default)({}, state, {
        subscriptionSwitchedFrom: state.subscription,
        subscription: action.result.subscription,
        quota: action.result.quota
      });

    case _topups.BUY_SUCCESS:
      if (action.result.isError) {
        return state;
      }

      return (0, _extends4.default)({}, state, {
        subscriptionSwitchedFrom: null,
        quota: action.result.quota
      });

    case _subscriptions.RESUME_SUBSCRIPTION_SUCCESS:
    case _subscriptions.CANCEL_SUBSCRIPTION_SUCCESS:
      return (0, _extends4.default)({}, state, {
        subscription: action.result.subscription
      });

    case _academicUsers.DOWNLOAD_SUCCESS:
      return _ramda2.default.over(_ramda2.default.lensPath(["academicOffer", "assetPacks"]), _ramda2.default.compose(_ramda2.default.apply(_ramda2.default.adjust(_ramda2.default.evolve({ downloadCount: _ramda2.default.inc }))), _ramda2.default.ap([_ramda2.default.findIndex(_ramda2.default.propEq("id", action.meta.packId)), _ramda2.default.identity]), _ramda2.default.append(_ramda2.default.__, [])), state);

    case MARK_FREE_SEEN:
      var drops = state.drops;
      if (drops) {
        drops.seen = true;
      }

      return (0, _extends4.default)({}, state, {
        drops: drops
      });

    case MARK_FREE_SEEN_SUCCCESS:
      return (0, _extends4.default)({}, state);

    case MARK_FREE_SEEN_FAIL:
      return (0, _extends4.default)({}, state);

    case ACTIVATE_TRIAL:
      return (0, _extends4.default)({}, state, {
        activatingTrial: true,
        activatedTrial: false,
        trialError: ""
      });

    case ACTIVATE_TRIAL_SUCCCESS:
      var trials = {};
      action.result.forEach(function (trial) {
        trials = (0, _extends4.default)({}, trials, (0, _defineProperty3.default)({}, trial.app + "Trial", trial));
      });

      return (0, _extends4.default)({}, state, trials, {
        activatingTrial: false,
        activatedTrial: true,
        trialError: ""
      });

    case ACTIVATE_TRIAL_FAIL:
      return (0, _extends4.default)({}, state, {
        activatingTrial: false,
        activatedTrial: false,
        trialError: "Error activating trial"
      });

    default:
      return state;
  }
}

// Helper functions

function isLoaded(globalState) {
  return globalState.user && globalState.user.loaded;
}

// Action creators
// flag will allow to reload self call even its loaded before.
function load(flag) {
  return function (dispatch, getState) {
    if (getState().auth.loggedIn && (flag || !getState().user.loaded) && !getState().user.loading) {
      return dispatch({
        types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
        promise: function promise(client) {
          return client.get("v1/users/self").then(function (result) {
            return client.get("sso://v1/users/" + result.email, { includeHeaders: true }).then(function (ssoResult) {
              var etag = ssoResult.headers.etag.replace(/["]+/g, "");

              return {
                user: (0, _extends4.default)({}, _ramda2.default.omit("name", ssoResult.data), result, {
                  etag: etag
                })
              };
            });
          });
        }
      });
    } else {
      return _bluebird2.default.resolve();
    }
  };
}

function markFreeSeen() {
  return {
    types: [MARK_FREE_SEEN, MARK_FREE_SEEN_SUCCCESS, MARK_FREE_SEEN_FAIL],
    promise: function promise(client) {
      return client.post("v1/users/drops/seen");
    }
  };
}
function activateTrial() {
  return {
    types: [ACTIVATE_TRIAL, ACTIVATE_TRIAL_SUCCCESS, ACTIVATE_TRIAL_FAIL],
    promise: function promise(client) {
      return client.post("v1/users/trial", {
        data: {
          app: "global"
        }
      });
    }
  };
}
function setWorkInfo(data) {
  return {
    types: [LOAD, _LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.post("v1/users/self/info", { data: data });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/user.js
// module id = 119
// module chunks = 0